// <copyright file="environment.prod.ts" company="Signify Holding">
//     Copyright © 2015 - 2021, All Rights Reserved.
// </copyright>

export const environment = {
    production: true,
    config: null,
};
